@if (!loading() && !error()) {
  <div id="device-errors--container">
    <div id="nav--container">
      <app-option-tab-toggle
        radioGroup="navigationToggle"
        [selectOptions]="navOptions()"
        type="round"
        id="toggle--container"
      >
      </app-option-tab-toggle>
    </div>
    <hr />
    <div id="inner-page--container">
      <div id="filter--container">
        <app-mat-fab-button
          id="refresh-btn"
          buttonStyle="success"
          iconName="restart_alt"
          (buttonClicked)="getExperimentDeviceErrorLog()"
          ariaLabel="Refresh"
        ></app-mat-fab-button>
        <app-icon-button
          label="filters"
          buttonStyle="secondary"
          buttonId="filter-btn"
          iconName="filter_list"
          buttonShape="square"
          (buttonClicked)="openModal('filter')"
          title="Filters"
        ></app-icon-button>
      </div>
      @if (deviceErrors()?.length > 0) {
        <p id="table-description" style="display: none">Device error table</p>
        <div id="table--container">
          <table aria-describedby="table-description">
            <thead>
              <tr>
                <th id="device-name" 
                    scope="col" 
                    (click)="onSort('Device')" 
                    [class.active]="currentSort().sortBy === 'Device'">
                  <div class="table-header">
                    <span>Device Name</span>
                    <mat-icon aria-label="sort direction" matTooltip="Sort direction">swap_vert</mat-icon>
                  </div>
                </th>
                <th
                  id="time"
                  scope="col"
                  (click)="onSort('Time')"
                  [class.active]="currentSort().sortBy === 'Time'"
                >
                  <div class="table-header">
                    <span>Time</span>
                    <mat-icon
                      aria-label="sort direction"
                      matTooltip="Sort direction"
                      >swap_vert</mat-icon
                    >
                  </div>
                </th>
                <th id="error-type" scope="col">
                  <div class="table-header">
                    <span>Error Type</span>
                  </div>
                </th>
                <th id="error-detail" scope="col">
                  <div class="table-header">
                    <span>Error Detail</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (error of deviceErrors(); track $index) {
                <tr>
                  <td headers="device-name">{{ error.deviceName }}</td>
                  <td headers="time">{{ error.time }}</td>
                  <td headers="error-type">{{ error.errorType }}</td>
                  <td headers="error-detail"><span class="error-detail">{{ error.errorDetail }}</span></td>
                </tr>
              }
            </tbody>
          </table>
          <div id="pagination--container">
            <div class="filter--container">
              <label for="requests-per-page">Requests per page</label>
              <app-dropdown-form-field
                id="requests-per-page"
                [field]="requestsPerPageField"
                [parentForm]="paginationControls"
              >
              </app-dropdown-form-field>
            </div>
            <div id="pagination--controls">
              <app-icon-button
                iconName="chevron_left"
                buttonId="previous"
                (buttonClicked)="getPrevious()"
                [isDisabled]="!hasPrevious()"
              ></app-icon-button>
              <span> {{ currentPage() }} / {{ totalPages() }} </span>
              <app-icon-button
                iconName="chevron_right"
                buttonId="next"
                (buttonClicked)="getNext()"
                [isDisabled]="!hasNext()"
              ></app-icon-button>
            </div>
          </div>
        </div>
      }
    </div>
    @if (!loading() && (!deviceErrors() || deviceErrors().length === 0)) {
      <div id="cta--container">
        <h4>No device errors detected</h4>
      </div>
    }
  </div>
} @else if (loading() && !error()) {
  <div id="loading-spinner"><app-loading-spinner></app-loading-spinner></div>
} @else if (!loading() && error()) {
  <app-error-page title="Error" [primaryText]="error()?.message"></app-error-page>
}
<app-filter-modal
  id="filter"
  primaryButtonText="Apply Filters"
  primaryButtonId="continue-button"
  secondaryButtonText="Reset"
  secondaryButtonId="reset-button"
  [modulesField]="errorTypeFilterField"
  [parentForm]="filterForm"
  [hideDeletedField]="true"
  checkboxStyle="list"
  (modalButtonClicked)="filterModalButtonClicked($event)"
  (moduleCheckboxClicked)="handleDeviceCheckbox($event)"
  [isProcessing]="loading()"
></app-filter-modal>
